<template>
  <div class="FlexGrid"
    :class="classes"
    :style="styles">

    <slot></slot>

  </div>
</template>

<script>
export default {
  props: {
    justify: {
      type: String,
      default: 'flex-start'
    },
    pad: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: 'top'
    }
  },

  mounted () {
    this.$nextTick(this.fixLastLine)
  },

  computed: {
    classes () {
      const classes = [
        `FlexGrid--align${this.align.charAt(0).toUpperCase() + this.align.slice(1)}`
      ]
      if (this.pad) classes.push('FlexGrid--isPadded')
      return classes
    },

    styles () {
      return {
        'justify-content': this.justify
      }
    }
  }
}
</script>

<style>
@import 'properties';

.FlexGrid {
  position: relative;
  display: flex;
  flex-wrap: wrap;
}

.FlexGrid--alignCenter {
  align-items: center;
}

.FlexGrid--alignTop {
  align-items: flex-start;
}

.FlexGrid--alignBottom {
  align-items: flex-end;
}

.FlexGrid--isPadded {
  margin-left: calc(var(--unit) * -1);
}

.FlexGrid--isPadded > * {
  padding-left: var(--unit);
}
</style>



// WEBPACK FOOTER //
// FlexGrid.vue?c2f7503e